import {
  equals,
  prop,
  ascend,
  descend,
  sort,
} from 'ramda';
// order: The sort order
export const ASC = 'asc';
export const DESC = 'desc';
// orderBy: These are the fields that will be needed for the sort.
export const SORT_BY_NAME_IN_ASC_LOAN_KEY = 'name';
// In this case we will just send the name
export const SORT_BY_NAME_IN_DESC_LOAN_KEY = 'name_desc';
export const SORT_BY_ASC_DATE = 'created_at';
export const SORT_BY_DESC_DATE = 'created_at_desc';
// orderBy: These are the fields that will be needed for the sort.
export const SORT_BY_ASSIGNEE_IN_ASC_LOAN_KEY = 'assignee';
// In this case we will just send the name
export const SORT_BY_ASSIGNEE_IN_DESC_LOAN_KEY = 'assignee_desc';

export const SORT_BY_APPLICATION_NUMBER_IN_ASC_LOAN_KEY = 'application_number';
// In this case we will just send the name
export const SORT_BY_APPLICATION_NUMBER_IN_DESC_LOAN_KEY = 'application_number_desc';

export const sortedTableData = (order: any, orderBy: any, rows: any) => {
  const sortByData = equals(order, ASC)
    ? ascend(prop(orderBy))
    : descend(prop(orderBy));

  return sort(sortByData, rows);
};
export const handleRequestSort = (
  event: any,
  property: any,
  order: any,
  orderBy: any,
  handleSetOrder: (order: any, orderBy: any) => void
) => {
  const isAsc = equals(orderBy, property) && equals(order, ASC);
  const sort = isAsc ? DESC : ASC;
  handleSetOrder(sort, property);
};
